@if (showRemainingDays) {
  <span class="whitespace-nowrap text-base font-semibold text-default">
    {{
      remainingDays > 1
        ? ('[daysLeft] days left' | translate | translationParams: { daysLeft: remainingDays })
        : ('Ends today' | translate)
    }}
  </span>
}
<button sb-button [color]="'primaryAlt'" (click)="openPlanWizard()">
  {{ planType === PlanType.FREE ? ('Upgrade plan' | translate) : ('Confirm plan' | translate) }}
</button>
